import { useContext } from 'react';
import { BrokerLoginContext } from 'src/context/broker-login/broker-login-context';

export default function useBrokerLogin() {
  const context = useContext(BrokerLoginContext);

  if (!context) {
    throw new Error('3PO revamp: useBrokerLogin should be used inside the BrokerLoginProvider.');
  }

  return context;
}
